<div class="contract-templates-container" role="main" aria-label="Gestione Template Contratti">
  <!-- Toast per messaggi -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>
  
  <!-- Breadcrumb -->
  <nav aria-label="Percorso di navigazione" class="mb-4">
    <p-breadcrumb 
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()" 
      [home]="{icon: 'pi pi-home', routerLink: '/', ariaLabel: 'Home'}">
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <header class="page-header">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-file-edit header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 class="text-2xl font-semibold" style="color: #00125b;">Editor Template</h1>
          <p class="subtitle text-sm" style="color: #495057;">Crea e personalizza i template utilizzando i blocchi di testo disponibili</p>
        </div>
      </div>
    </div>
  </header>

  <!-- Template Title - Full Width -->
  <div class="mb-4">
    <label for="template-title" class="block mb-2 text-lg font-semibold" style="color: #00125b;">
      Nome Template <span class="text-red-500" aria-label="campo obbligatorio">*</span>
    </label>
    <input 
      id="template-title"
      type="text" 
      pInputText 
      [(ngModel)]="templateName"
      (ngModelChange)="markAsModified()"
      placeholder="Inserisci il nome del template..."
      class="w-full"
      aria-label="Nome del template"
      aria-required="true"
      aria-describedby="template-title-desc"
    />
    <small id="template-title-desc" class="block mt-1" style="color: #495057;">Inserisci un nome identificativo per il template</small>
  </div>

  <!-- Template Description - Optional -->
  <div class="mb-4">
    <label for="template-description" class="block mb-2 text-lg font-semibold" style="color: #00125b;">
      Descrizione <span class="text-sm font-normal" style="color: #495057;">(opzionale)</span>
    </label>
    <textarea 
      id="template-description"
      rows="3"
      pInputText
      [(ngModel)]="templateDescription"
      (ngModelChange)="markAsModified()"
      placeholder="Inserisci una descrizione del template..."
      maxlength="1000"
      class="w-full"
      aria-label="Descrizione del template"
      aria-describedby="template-description-desc template-description-counter"
      style="resize: vertical;"
    ></textarea>
    <div class="flex justify-content-between align-items-center mt-1">
      <small id="template-description-desc" style="color: #495057;">Aggiungi una descrizione dettagliata del template</small>
      <small id="template-description-counter" style="color: #495057;" aria-live="polite">
        {{ templateDescription.length }}/1000 caratteri
      </small>
    </div>
  </div>

  <!-- Domain Type and SubDomain Type Selection -->
  <div class="grid mb-4" role="group" aria-labelledby="classification-heading">
    <div class="col-12 mb-2">
      <h2 id="classification-heading" class="text-lg font-semibold sr-only">Classificazione Template</h2>
    </div>
    <div class="col-12 md:col-6 mb-3 md:mb-0">
      <label for="domain-type" class="font-semibold block mb-2" style="color: #00125b;">
        Destinatario <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <p-select
        inputId="domain-type"
        [options]="domainTypeOptions"
        [(ngModel)]="domainType"
        (ngModelChange)="markAsModified()"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleziona destinatario"
        styleClass="w-full"
        [disabled]="isDomainTypeDisabled()"
        [attr.aria-required]="true"
      >
      </p-select>
    </div>
    <div class="col-12 md:col-6">
      <label for="subdomain-type" class="font-semibold block mb-2" style="color: #00125b;">
        Scopo <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <p-select
        inputId="subdomain-type"
        [options]="subDomainTypeOptions"
        [(ngModel)]="subDomainType"
        (ngModelChange)="markAsModified()"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleziona scopo"
        styleClass="w-full"
        [attr.aria-required]="true"
        [attr.aria-describedby]="'subdomain-type-desc'"
      >
      </p-select>
      <small id="subdomain-type-desc" class="block mt-1" style="color: #495057;">Indica la finalità del documento</small>
    </div>
  </div>

  <!-- Attachments Section -->
  <div class="mb-4">
    <p-accordion [multiple]="true">
      <!-- Section Attachments (Read-only) -->
      <p-accordion-panel>
        <p-accordion-header>
          <div class="flex align-items-center gap-2">
            <i class="pi pi-paperclip" aria-hidden="true" style="color: #00125b;"></i>
            <span class="font-semibold" style="color: #00125b;">Allegati dai Blocchi di Testo</span>
            @if (sectionAttachments().length > 0) {
              <p-badge [value]="sectionAttachments().length.toString()" severity="secondary"></p-badge>
            }
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="mb-2">
            <small style="color: #495057;">
              <i class="pi pi-info-circle" aria-hidden="true"></i>
              Questi allegati vengono automaticamente inclusi dai blocchi di testo selezionati.
            </small>
          </div>
          @if (sectionAttachments().length === 0) {
            <div class="text-center p-3" style="color: #6c757d; font-style: italic;">
              Nessun allegato automatico. Gli allegati verranno aggiunti quando selezioni blocchi di testo che li contengono.
            </div>
          } @else {
            <div class="flex flex-column gap-2">
              @for (attachment of sectionAttachments(); track attachment.id) {
                <div class="flex align-items-center gap-2 p-2" style="border: 1px solid #dee2e6; border-radius: 4px; background: #f8f9fa;">
                  <i class="pi pi-file" aria-hidden="true" style="color: #6c757d;"></i>
                  <div class="flex-1">
                    <div class="font-medium" style="color: #00125b;">{{ attachment.title }}</div>
                    @if (attachment.description) {
                      <small style="color: #6c757d;">{{ attachment.description }}</small>
                    }
                  </div>
                  <p-badge value="Auto" severity="secondary"></p-badge>
                </div>
              }
            </div>
          }
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Optional Template Attachments (Editable) -->
      <p-accordion-panel>
        <p-accordion-header>
          <div class="flex align-items-center gap-2">
            <i class="pi pi-paperclip" aria-hidden="true" style="color: #ff6b6b;"></i>
            <span class="font-semibold" style="color: #00125b;">Allegati Opzionali del Template</span>
            @if (optionalAttachments().length > 0) {
              <p-badge [value]="optionalAttachments().length.toString()" [style]="{'background': 'linear-gradient(135deg, #ff6b6b 0%, #ffa500 100%)'}"></p-badge>
            }
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="mb-3">
            <small style="color: #495057;">
              <i class="pi pi-info-circle" aria-hidden="true"></i>
              Questi allegati sono specifici per il template e possono essere aggiunti o rimossi liberamente.
            </small>
          </div>
          
          <!-- List of Optional Attachments -->
          @if (optionalAttachments().length > 0) {
            <div class="flex flex-column gap-2 mb-3">
              @for (attachment of optionalAttachments(); track attachment.id) {
                <div class="flex align-items-center gap-2 p-2" style="border: 1px solid #ffa500; border-radius: 4px; background: #fff7ed;">
                  <i class="pi pi-file" aria-hidden="true" style="color: #ff6b6b;"></i>
                  <div class="flex-1">
                    <div class="font-medium" style="color: #00125b;">{{ attachment.title }}</div>
                    @if (attachment.description) {
                      <small style="color: #6c757d;">{{ attachment.description }}</small>
                    }
                  </div>
                  <p-button
                    icon="pi pi-times"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    size="small"
                    [attr.aria-label]="'Rimuovi allegato ' + attachment.title"
                    pTooltip="Rimuovi allegato"
                    (onClick)="removeOptionalAttachment(attachment.id)"
                  ></p-button>
                </div>
              }
            </div>
          }

          <!-- Add Attachment Button -->
          <div class="flex justify-content-start">
            <p-button
              label="Aggiungi Allegato"
              icon="pi pi-plus"
              [outlined]="true"
              size="small"
              (onClick)="showAddAttachmentDialog()"
              [attr.aria-label]="'Aggiungi nuovo allegato opzionale'"
            ></p-button>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <div class="template-wrapper">
    <!-- LEFT COLUMN — AVAILABLE SECTIONS -->
    <section class="column column-left" aria-labelledby="available-sections-title">
      <h2 id="available-sections-title">Blocchi di Testo Disponibili</h2>

      <!-- Search Bar -->
      <div class="mb-3">
        <label for="search-sections" class="block mb-2 font-medium" style="color: #00125b;">Cerca sezioni</label>
        <input 
          id="search-sections"
          type="text" 
          pInputText 
          [(ngModel)]="searchQuery"
          (input)="filterSections()"
          placeholder="Cerca blocchi di testo..."
          class="w-full"
          aria-label="Cerca tra i blocchi di testo disponibili"
        />
      </div>

      <!-- Multiple panels can be open simultaneously -->
      <p-accordion [multiple]="true">
        @for (s of filteredSections(); track s.id) {
        <p-accordion-panel 
          [value]="s.id"
          class="draggable-section"
          [attr.aria-label]="'Sezione: ' + s.title"
        >
          <p-accordion-header>
            <div class="flex align-items-center justify-content-between w-full"
                 draggable="true"
                 tabindex="0"
                 role="button"
                 [attr.aria-label]="'Trascina sezione ' + s.title"
                 (dragstart)="onDragStartSection($event, s)"
                 (dragend)="onDragEndSection($event)">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-bars drag-handle" aria-hidden="true"></i>
                <span>{{ s.title }}</span>
              </div>
              <p-button
                icon="pi pi-plus"
                [rounded]="true"
                [outlined]="true"
                severity="success"
                styleClass="add-section-btn"
                [attr.aria-label]="'Aggiungi sezione ' + s.title + ' al template'"
                (onClick)="addSection(s); $event.stopPropagation()"
                pTooltip="Aggiungi al template"
              >
              </p-button>
            </div>
          </p-accordion-header>
          <p-accordion-content>
            <div class="section-text" 
                 [innerHTML]="sanitizeAndFormatContent(s.content)"></div>
          </p-accordion-content>
        </p-accordion-panel>
        }
      </p-accordion>
    </section>

    <!-- RIGHT COLUMN — SELECTED SECTIONS -->
    <section 
      class="column drop-zone"
      aria-labelledby="selected-sections-title"
      [attr.aria-label]="'Area di rilascio per sezioni selezionate, ' + selectedSections().length + ' sezioni'"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
      <h2 id="selected-sections-title">Blocchi di Testo Selezionati</h2>

      <div class="sections-list-wrapper">
        @if (selectedSections().length === 0) {
        <div class="empty-box drop-area" role="status" aria-live="polite">Trascina le sezioni qui o clicca sul pulsante Aggiungi</div>
        }

        <p-accordion [multiple]="true">
          @for (s of selectedSections(); track $index; let idx = $index) {
          <p-accordion-panel 
            [value]="idx"
            class="draggable-section selected-draggable"
            draggable="true"
            [attr.aria-label]="'Sezione ' + (idx + 1) + ': ' + s.title"
            [attr.aria-describedby]="'section-' + idx + '-desc'"
            (dragstart)="onDragStartSelected($event, s, idx)"
            (dragend)="onDragEndSelected($event)"
            (dragover)="onDragOverSelected($event, idx)"
            (dragleave)="onDragLeaveSelected($event)"
            (drop)="onDropSelected($event, idx)"
          >
            <p-accordion-header>
              <div class="flex align-items-center gap-2 w-full"
                   tabindex="0"
                   role="button"
                   [attr.aria-label]="'Trascina per riordinare: sezione ' + (idx + 1) + ', ' + s.title">
                <i class="pi pi-bars drag-handle" aria-hidden="true"></i>
                <span class="section-number" aria-hidden="true">{{ idx + 1 }}.</span>
                <span>{{ s.title }}</span>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <div class="section-text" [innerHTML]="sanitizeAndFormatContent(s.content)"></div>
              <span [id]="'section-' + idx + '-desc'" class="sr-only">Posizione {{ idx + 1 }} di {{ selectedSections().length }}</span>
              <div class="flex justify-content-end gap-2 mt-2" role="group" [attr.aria-label]="'Azioni per ' + s.title">
                <p-button
                  label="Modifica nel Registro"
                  icon="pi pi-external-link"
                  [outlined]="true"
                  size="small"
                  [attr.aria-label]="'Vai al registro per modificare ' + s.title"
                  pTooltip="Apri il blocco di testo nel registro per modificarlo"
                  (onClick)="editSection(s, idx)"
                ></p-button>
                <p-button
                  label="Rimuovi"
                  icon="pi pi-times"
                  severity="danger"
                  [outlined]="true"
                  size="small"
                  [attr.aria-label]="'Rimuovi sezione dal template'"
                  pTooltip="Rimuovi dal template"
                  (onClick)="removeSection(idx)"
                ></p-button>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
          }
        </p-accordion>
      </div>

      <div class="mt-4 flex justify-content-between gap-2" role="group" aria-label="Azioni template">
        <!-- Pulsanti a sinistra: Anteprima e Scarica Word -->
        <div class="flex gap-2">
          <p-button
            label="Anteprima"
            icon="pi pi-eye"
            [outlined]="true"
            [disabled]="selectedSections().length === 0"
            [attr.aria-label]="'Visualizza anteprima del contratto con ' + selectedSections().length + ' sezioni'"
            pTooltip="Visualizza anteprima del template"
            (onClick)="openPreview()"
          ></p-button>
        </div>
        
        <!-- Pulsanti a destra: Annulla e Salva Template -->
        <div class="flex gap-2">
          <p-button
            *ngIf="isFromRegistry || isCloneMode"
            label="Annulla"
            [outlined]="true"
            severity="secondary"
            [attr.aria-label]="'Torna al registro template'"
            pTooltip="Torna al registro senza salvare"
            (onClick)="cancelTemplate()"
          ></p-button>
          <p-button
            label="Salva Bozza"
            icon="pi pi-save"
            [outlined]="true"
            styleClass="btn-draft"
            [disabled]="!templateName || selectedSections().length === 0"
            [attr.aria-label]="'Salva il template come bozza con ' + selectedSections().length + ' sezioni'"
            pTooltip="Salva come bozza per modifiche successive"
            (onClick)="saveDraft()"
          ></p-button>
          <p-button
            label="Salva Template"
            icon="pi pi-check"
            iconPos="right"
            severity="primary"
            [disabled]="!templateName || selectedSections().length === 0"
            [attr.aria-label]="'Salva il template con ' + selectedSections().length + ' sezioni'"
            pTooltip="Salva template e rendi attivo"
            (onClick)="saveTemplate()"
          ></p-button>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- ================= EDIT DIALOG WITH TINYMCE ================= -->
<p-dialog
  [(visible)]="editVisible"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [contentStyle]="{ 'max-height': '70vh' }"
  [attr.role]="'dialog'"
  [attr.aria-modal]="'true'"
  [attr.aria-labelledby]="'edit-dialog-title'"
>
  <ng-template pTemplate="header">
    <h3 id="edit-dialog-title" style="margin: 0; color: #00125b;">Modifica Sezione</h3>
  </ng-template>
  <div class="edit-dialog-content">
    <!-- Variables Panel -->
    <aside class="variables-sidebar" aria-labelledby="variables-title">
      <h4 id="variables-title">Variabili</h4>
      <div class="variables-list" role="list" aria-label="Lista variabili disponibili">
        @for (variable of variables; track variable.key) {
          <div
            class="variable-item"
            role="listitem"
            tabindex="0"
            [attr.aria-label]="'Variabile: ' + variable.displayName"
            (click)="insertVariable(variable.key)"
            (keydown.enter)="insertVariable(variable.key)"
            (keydown.space)="insertVariable(variable.key); $event.preventDefault()"
            [pTooltip]="variable.displayName"
          >
            <span class="variable-key" aria-hidden="true">{{'{{'}}{{ variable.key }}{{'}}'}}</span>
          </div>
        }
      </div>
    </aside>

    <!-- Jodit Editor -->
    <div class="editor-area" role="region" aria-label="Area di modifica contenuto">
      <div #joditEditor id="jodit-editor" aria-label="Editor di testo per modificare il contenuto della sezione"></div>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <p-button 
      label="Annulla" 
      [variant]="'outlined'" 
      severity="secondary" 
      [attr.aria-label]="'Annulla modifiche alla sezione'"
      pTooltip="Annulla senza salvare le modifiche"
      (onClick)="cancelEdit()"></p-button>
    <p-button 
      label="Salva" 
      icon="pi pi-check" 
      [attr.aria-label]="'Salva modifiche alla sezione'"
      pTooltip="Salva le modifiche alla sezione"
      (onClick)="saveEdit()"></p-button>
  </ng-template>
</p-dialog>

<!-- ================= PREVIEW DIALOG WITH PDF AND WORD BUTTONS ================= -->
<p-dialog
  [(visible)]="previewVisible"
  [modal]="true"
  [style]="{width: '90vw', maxWidth: '1200px'}"
  [maximizable]="true"
  [draggable]="false"
  styleClass="preview-dialog"
  [attr.role]="'dialog'"
  [attr.aria-modal]="'true'"
  [attr.aria-labelledby]="'preview-dialog-title'"
  (onHide)="closePreview()"
>
  <ng-template pTemplate="header">
    <h3 id="preview-dialog-title" style="margin: 0; color: #00125b;">Anteprima Template</h3>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="preview-content-wrapper" style="max-height: 70vh; overflow-y: auto; padding: 2rem; background: white; border: 1px solid #e5e7eb; border-radius: 8px;">
      <div [innerHTML]="sanitizeContent(previewContent())" class="preview-content"></div>
    </div>
    <div *ngIf="isGenerating()" 
         class="flex align-items-center gap-2 mt-3 p-3 bg-blue-50 border-round" 
         role="status" 
         aria-live="polite" 
         aria-atomic="true">
      <i class="pi pi-spin pi-spinner text-blue-600" aria-hidden="true"></i>
      <span class="text-blue-800 font-medium">Generazione documento in corso...</span>
    </div>
  </ng-template>
  
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full">
      <div class="flex gap-2">
        <p-button
          label="Scarica Word"
          icon="pi pi-file-word"
          [outlined]="true"
          severity="primary"
          [disabled]="isGenerating()"
          [attr.aria-label]="'Scarica come documento Word'"
          pTooltip="Esporta come documento Word (.docx)"
          (onClick)="generateWord()"
        ></p-button>
        <p-button
          label="Scarica PDF"
          icon="pi pi-file-pdf"
          [outlined]="true"
          severity="danger"
          [disabled]="isGenerating()"
          [attr.aria-label]="'Scarica come documento PDF'"
          pTooltip="Esporta come documento PDF"
          (onClick)="generatePdf()"
        ></p-button>
      </div>
      <p-button
        label="Chiudi"
        icon="pi pi-times"
        severity="secondary"
        [outlined]="true"
        [attr.aria-label]="'Chiudi anteprima'"
        pTooltip="Chiudi finestra anteprima"
        (onClick)="closePreview()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
<!-- ================= ADD ATTACHMENT DIALOG ================= -->
<p-dialog
  [(visible)]="addAttachmentDialogVisible"
  [modal]="true"
  [style]="{ width: '600px' }"
  [contentStyle]="{ 'max-height': '70vh' }"
  [attr.role]="'dialog'"
  [attr.aria-modal]="'true'"
  [attr.aria-labelledby]="'add-attachment-dialog-title'"
>
  <ng-template pTemplate="header">
    <h3 id="add-attachment-dialog-title" style="margin: 0; color: #00125b;">Aggiungi Allegato Opzionale</h3>
  </ng-template>
  
  <div class="p-3">
    <!-- Search Bar -->
    <div class="mb-3">
      <label for="search-attachments" class="block mb-2 font-medium" style="color: #00125b;">Cerca allegati</label>
      <input 
        id="search-attachments"
        type="text" 
        pInputText 
        [(ngModel)]="attachmentSearchQuery"
        placeholder="Cerca allegati disponibili..."
        class="w-full"
        aria-label="Cerca tra gli allegati disponibili"
      />
    </div>

    <!-- Available Attachments List -->
    @if (getFilteredAvailableAttachments().length === 0) {
      <div class="text-center p-3" style="color: #6c757d; font-style: italic;">
        @if (attachmentSearchQuery) {
          Nessun allegato trovato con "{{ attachmentSearchQuery }}"
        } @else {
          Nessun allegato disponibile
        }
      </div>
    } @else {
      <div class="flex flex-column gap-2" style="max-height: 400px; overflow-y: auto;">
        @for (attachment of getFilteredAvailableAttachments(); track attachment.id) {
          <div 
            class="flex align-items-center gap-2 p-2" 
            style="border: 1px solid #dee2e6; border-radius: 4px; cursor: pointer; transition: background 0.2s;"
            [style.background]="isAttachmentInOptional(attachment.id) ? '#e3f2fd' : 'white'"
            [style.border-color]="isAttachmentInOptional(attachment.id) ? '#2196f3' : '#dee2e6'"
            (click)="toggleAttachmentSelection(attachment.id)"
            role="button"
            [attr.aria-pressed]="isAttachmentInOptional(attachment.id)"
            [attr.aria-label]="(isAttachmentInOptional(attachment.id) ? 'Rimuovi: ' : 'Aggiungi: ') + attachment.title"
          >
            <i 
              [class]="isAttachmentInOptional(attachment.id) ? 'pi pi-check-circle' : 'pi pi-circle'" 
              [style.color]="isAttachmentInOptional(attachment.id) ? '#2196f3' : '#6c757d'"
              aria-hidden="true"
            ></i>
            <div class="flex-1">
              <div class="font-medium" style="color: #00125b;">{{ attachment.title }}</div>
              @if (attachment.description) {
                <small style="color: #6c757d;">{{ attachment.description }}</small>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
  
  <ng-template pTemplate="footer">
    <p-button 
      label="Chiudi" 
      icon="pi pi-times"
      [variant]="'outlined'" 
      severity="secondary" 
      [attr.aria-label]="'Chiudi dialog selezione allegati'"
      pTooltip="Chiudi finestra"
      (onClick)="closeAddAttachmentDialog()"
    ></p-button>
  </ng-template>
</p-dialog>